import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

// A simple modal component rendered via a portal.
const Modal = ({ modalImage, onClose }) => {
    return ReactDOM.createPortal(
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            }}
        >
            <img
                src={modalImage}
                alt="Enlarged"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: '5px' }}
            />
        </div>,
        document.body
    );
};

const CommentWithImageModal = ({ reply, currentUser, highlightMentions }) => {

    // State to store the clicked image.
    const [modalImage, setModalImage] = useState(null);

    // Ref for the container that holds the HTML content.
    const commentRef = useRef(null);

    // Parse @[name](id) to HTML span for mentions
    const parseMentionsToHTML = (text) => {
        return text.replace(/@\[(.+?)\]\((\d+)\)/g, (match, name, id) => {
            const isCurrentUser = name.toLowerCase() === localStorage.user_name?.toLowerCase();
            const className = isCurrentUser ? 'mention highlight' : 'mention';
            return `<span class="${className}" data-id="${id}">@${name}</span>`;
        });
    };

    // Attaches click listeners to images within the comment container.
    const handleImageClick = (event) => {
        setModalImage(event.target.src);
    };

    useEffect(() => {
        const container = commentRef.current;
        if (!container) return;

        // Get all image elements within this container.
        const imgElements = container.querySelectorAll('img');
        imgElements.forEach((img) => {
            img.style.cursor = 'pointer';
            img.addEventListener('click', handleImageClick);
        });

        // Cleanup the listeners on unmount or when reply.content changes.
        return () => {
            imgElements.forEach((img) => {
                img.removeEventListener('click', handleImageClick);
            });
        };
    }, [reply.content]);

    return (
        <div className="display-flex align-items-flex-end flex-direction-column" key={reply.id}>

            <div className={"display-flex"}  style={{maxWidth: "70%"}}>
                <div className={"border-radius-round h-100 "}>
                    <span className={"display-flex align-items-center justify-content-center"}>
                        <div className={"border-radius-round h-100 mt-10"} style={{backgroundColor: reply.color}}>
                            <span className={"display-flex align-items-center justify-content-center"}
                                  style={{height: 40, width: 40}}>

                                <strong
                                    style={{fontSize: ".8rem"}}>{(reply?.username_display && reply.username_display.split(' ').map(word => word[0]).join('')) || reply.username}</strong>
                            </span>
                        </div>
                    </span>
                </div>
                <div
                    style={{
                        marginBottom: 10,
                        padding: '0 0 0 20px',
                        borderRadius: '5px',
                        flexDirection: 'column',
                        display: 'flex',
                        gap: 20,
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* Wrap all potentially dynamic content in a single ref container */}
                    <div
                        ref={commentRef}
                        style={{
                            padding: 20,
                            backgroundColor: 'rgb(204 204 204 / 65%)',
                            color: 'black',
                            width: '100%',
                            borderRadius: '5px',
                        }}
                        className="display-flex flex-direction-column justify-content-space-between"
                    >

          <span
              className="comment"
              dangerouslySetInnerHTML={{
                  __html: parseMentionsToHTML(reply.content),
              }}
          />
                        <div className="h-separator mt-20 mb-10" style={{backgroundColor: 'white'}}></div>

                        <div>
                            <strong>
                                <span dangerouslySetInnerHTML={{__html: reply.username}}/>
                            </strong>
                            &nbsp;le&nbsp;
                            <span>{new Date(reply.date).toLocaleString()}</span>
                        </div>
                    </div>
                </div>

                {/* Render the modal using a portal if an image has been clicked */}
                {modalImage && (
                    <Modal modalImage={modalImage} onClose={() => setModalImage(null)}/>
                )}
            </div></div>
    );
};

export default CommentWithImageModal;